/**
 * Bimini Cats: lead tracking snippet for the Shopify theme.
 *
 * 1. Saves ad click identifiers (fbclid, gclid, gbraid, wbraid, UTM) on every page,
 *    so they are not lost when a visitor moves between pages before the form.
 * 2. On form submit: remembers the lead (with a shared event id) in sessionStorage.
 * 3. On the next page load, only if the theme shows the form success message
 *    (so the captcha was passed and Shopify accepted the form): fires the browser
 *    Lead event with that event id and sends the same lead to our Worker
 *    (which sends it to Meta and the Google Sheet).
 *
 * Setup in the theme (layout/theme.liquid, before </body>):
 *   <script>window.BIMINI_CAPI = { endpoint: "https://<worker>.workers.dev/lead" };</script>
 *   <script src="{{ 'bimini-capi.js' | asset_url }}" defer></script>
 *
 * Forms are matched by the data-kitten-form wrapper already used in the theme.
 * The theme's own fbq Lead (layout/theme.liquid, pushOnSuccess) must be removed,
 * otherwise the browser Lead is counted twice.
 */
(function () {
  var CFG = window.BIMINI_CAPI || {};
  var STORE_KEY = 'bimini_click_ids';
  var PENDING_KEY = 'bimini_pending_capi';
  var MAX_AGE_DAYS = 90;
  var PENDING_MAX_MIN = 30;
  var PARAMS = ['fbclid', 'gclid', 'gbraid', 'wbraid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

  function readStore() {
    try {
      var raw = JSON.parse(localStorage.getItem(STORE_KEY) || 'null');
      if (raw && Date.now() - raw.t < MAX_AGE_DAYS * 864e5) return raw.v || {};
    } catch (e) {}
    return {};
  }

  function writeStore(v) {
    try { localStorage.setItem(STORE_KEY, JSON.stringify({ t: Date.now(), v: v })); } catch (e) {}
  }

  // Last-touch: new click identifiers from the current URL replace the old ones.
  function captureFromUrl() {
    var qs = new URLSearchParams(location.search);
    var found = {};
    var any = false;
    PARAMS.forEach(function (p) {
      var val = qs.get(p);
      if (val) { found[p] = val; any = true; }
    });
    if (any) writeStore(found);
  }

  function cookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }

  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'id-' + Date.now() + '-' + Math.random().toString(16).slice(2);
  }

  function field(form, name) {
    var el = form.querySelector('[name="contact[' + name + ']"]');
    return el ? (el.value || '').trim() : '';
  }

  // Submit: only remember the lead. Nothing is counted yet, the captcha or the
  // server side validation may still reject the form.
  function onSubmit(ev) {
    var form = ev.target;
    if (!form) return;
    if (form.checkValidity && !form.checkValidity()) return;

    var wrapper = form.closest('[data-kitten-form]');
    var ids = readStore();

    var payload = {
      event_name: 'Lead',
      event_id: uuid(),
      event_source_url: location.href,
      fbp: cookie('_fbp'),
      fbc: cookie('_fbc'),
      name: field(form, 'name'),
      email: field(form, 'email'),
      phone: field(form, 'phone'),
      breed_interest: field(form, 'breed_interested_in'),
      message: field(form, 'body'),
      form_type: wrapper ? wrapper.getAttribute('data-kitten-form') : '', // value of data-kitten-form on the page (e.g. waitlist)
      website: '' // honeypot, stays empty for people
    };
    PARAMS.forEach(function (p) { if (ids[p]) payload[p] = ids[p]; });

    try {
      sessionStorage.setItem(PENDING_KEY, JSON.stringify({
        t: Date.now(),
        formType: wrapper ? wrapper.getAttribute('data-kitten-form') : '',
        payload: payload
      }));
    } catch (e) {}
  }

  // Next page load: the theme renders .contact-form__success only after Shopify
  // accepted the form. That is the moment the lead is real.
  function sendIfAccepted() {
    var pending;
    try { pending = JSON.parse(sessionStorage.getItem(PENDING_KEY) || 'null'); } catch (e) { pending = null; }
    if (!pending || !pending.payload) return;

    if (Date.now() - pending.t > PENDING_MAX_MIN * 60000) {
      try { sessionStorage.removeItem(PENDING_KEY); } catch (e) {}
      return;
    }

    var selector = '[data-kitten-form="' + pending.formType + '"] .contact-form__success';
    if (!document.querySelector(selector)) return;

    try { sessionStorage.removeItem(PENDING_KEY); } catch (e) {}

    var payload = pending.payload;
    // Cookies may have been created after the form was submitted (first visit).
    payload.fbp = payload.fbp || cookie('_fbp');
    payload.fbc = payload.fbc || cookie('_fbc');

    // Browser event with the same id the server will use (deduplication).
    try {
      if (window.fbq) fbq('track', 'Lead', {}, { eventID: payload.event_id });
    } catch (e) {}

    if (CFG.endpoint) {
      try {
        fetch(CFG.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
          keepalive: true
        }).catch(function () {});
      } catch (e) {}
    }
  }

  captureFromUrl();
  // In the theme data-kitten-form sits on the wrapper div, the <form> is inside it.
  document.addEventListener('submit', function (ev) {
    var t = ev.target;
    if (t && t.tagName === 'FORM' && t.closest && t.closest('[data-kitten-form]')) onSubmit(ev);
  }, true);
  sendIfAccepted();
})();
